import EventProLayout from 'event/Layout';
import EventNewsContainer, { getServerSidePageProps } from 'event/containers/news/EventNewsContainer';

import { END } from 'redux-saga';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { reduxWrapper } from 'store/configureStore';

export const getServerSideProps = reduxWrapper.getServerSideProps((store) => async ({ locale }) => {
  const { props, ns = [], isNotFound } = await getServerSidePageProps({ store, locale });

  if (isNotFound) return { notFound: true };

  store.dispatch(END);
  await store.sagaTask.toPromise();

  return {
    props: {
      ...props,
      locale,
      ...(await serverSideTranslations(locale, [...ns, 'common', 'footer']))
    }
  };
});

EventNewsContainer.Layout = EventProLayout;

export default EventNewsContainer;
